import { useState } from "react";
import { Product } from "../types/Product";
import { useProductList } from "./useProductList";

export const useProduct = () => {
  const productList = useProductList();
  const [allProducts, setAllProducts] = useState<Record<string, Product[]>>(
    JSON.parse(localStorage.getItem("allProducts") || "{}"),
  );
  const products = allProducts[productList.current] || [];

  const setProducts = (products: Product[]) => {
    const newAllProducts = { ...allProducts, [productList.current]: products };
    localStorage.setItem("allProducts", JSON.stringify(newAllProducts));
    setAllProducts(newAllProducts);
  };

  const clearProducts = () => {
    const newAllProducts = { ...allProducts };
    delete newAllProducts[productList.current];
    localStorage.setItem("transactions", JSON.stringify(newAllProducts));
    setAllProducts(newAllProducts);
  };
  return { products, setProducts, clearProducts, allProducts };
};
